import { Link } from "react-router-dom";
import Navbar from "../components/Navbaar";
import Footer from "../components/Footer";
import SEO from "../components/SEO/SEO";
import TicketCard from "../components/TicketCard";
import useReveal from "../hooks/useReveal";
import { LeafIcon, DropletIcon, CarIcon, SparkleIcon } from "../components/icons";
import styles from "./Home.module.css";

function RevealSection({ as: Tag = "div", className = "", children, ...rest }) {
  const { ref, isVisible } = useReveal();
  return (
    <Tag
      ref={ref}
      className={`reveal ${isVisible ? "isVisible" : ""} ${className}`}
      {...rest}
    >
      {children}
    </Tag>
  );
}

function Home() {
  return (
    <>
      <SEO
        title="BOI Gardens & Car Cleaning | Kerikeri NZ"
        description="Professional gardening and car cleaning services in Kerikeri New Zealand."
      />

      <Navbar />

      <section className={styles.hero}>
        <div className={styles.heroBg} aria-hidden="true" />
        <div className={styles.heroInner}>
          <div className={styles.heroCopy}>
            <span className="eyebrow">Kerikeri &amp; the Bay of Islands</span>
            <h1>
              Gardens kept tidy.
              <br />
              Cars kept <em>shining</em>.
            </h1>
            <p>
              One local team, two things done properly: garden maintenance
              that keeps your section under control, and a car wash that
              actually gets the inside too.
            </p>
            <div className={styles.heroActions}>
              <Link to="/booking" className="btn btnPrimary">
                Book a service
              </Link>
              <Link to="/services" className="btn btnGhost">
                See pricing
              </Link>
            </div>
          </div>

          <div className={styles.heroStage} aria-hidden="true">
            <TicketCard
              className={`${styles.heroTicket} ${styles.ticketOne}`}
              icon={<LeafIcon />}
              label="Garden care"
              title="Mowing &amp; tidy"
              price="$40"
              unit="/ hr"
              tilt="-6deg"
              float="slow"
            />
            <TicketCard
              className={`${styles.heroTicket} ${styles.ticketTwo}`}
              icon={<DropletIcon />}
              label="Car cleaning"
              title="Full inside &amp; out"
              price="$125"
              tilt="4deg"
              float="med"
            />
          </div>
        </div>
      </section>

      <section className={styles.trust}>
        <div className={styles.trustInner}>
          <span className={styles.trustItem}>
            <SparkleIcon /> Locally owned &amp; operated
          </span>
          <span className={styles.trustItem}>
            <SparkleIcon /> Serving Kerikeri &amp; surrounds
          </span>
          <span className={styles.trustItem}>
            <SparkleIcon /> Flexible booking times
          </span>
        </div>
      </section>

      <section className={styles.services}>
        <RevealSection as="div" className={styles.sectionHead}>
          <span className="eyebrow">What we do</span>
          <h2>Two services, one reliable team</h2>
          <p>
            Pick one or book both — most customers do, since a tidy garden
            and a clean car tend to go together.
          </p>
        </RevealSection>

        <div className={styles.panelGrid}>
          <RevealSection as="div" className={`${styles.panel} ${styles.panelGarden}`}>
            <div className={styles.panelGlow} aria-hidden="true" />
            <LeafIcon className={styles.panelIcon} />
            <h3>Gardening</h3>
            <p>
              Mowing, edging, hedge trims and general tidy-ups — charged
              hourly, however long the section takes.
            </p>
            <Link to="/services" className={styles.panelLink}>
              View pricing →
            </Link>
          </RevealSection>

          <RevealSection as="div" className={`${styles.panel} ${styles.panelCar}`}>
            <div className={styles.panelGlow} aria-hidden="true" />
            <CarIcon className={styles.panelIcon} />
            <h3>Car cleaning</h3>
            <p>
              Exterior wash, interior clean, or the full inside &amp; out
              package for a car that feels new again.
            </p>
            <Link to="/services" className={styles.panelLink}>
              View pricing →
            </Link>
          </RevealSection>
        </div>
      </section>

      <RevealSection as="section" className={styles.ctaBand}>
        <h2>Ready to get booked in?</h2>
        <p>Drop us a message with what you need and where you are.</p>
        <Link to="/booking" className="btn btnPrimary">
          Book a service
        </Link>
      </RevealSection>

      <Footer />
    </>
  );
}

export default Home;
